// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/reset.min.css
// module id = urR3
// module chunks = 12